@use '@hevoio/hevo-ui-toolkit/styles/variables' as hevo-toolkit-variables;

.buttonWrapper {
  width: fit-content;
  display: inline-block;
  margin:  hevo-toolkit-variables.$spacer * 0.65  hevo-toolkit-variables.$spacer * 0.32;
  margin-bottom: 0;
  padding-bottom: 0;
}
